import { render, staticRenderFns } from "./ShoppingCartAlertsStep.vue?vue&type=template&id=2a04f0df&scoped=true&"
import script from "./ShoppingCartAlertsStep.vue?vue&type=script&lang=js&"
export * from "./ShoppingCartAlertsStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a04f0df",
  null
  
)

export default component.exports